/**
 * 是否拥有供应方身份
 */
export function hasSupplierRole(userInfo) {
  if (!userInfo || !userInfo.roleId) {
    return false
  }
  const roleId = userInfo.roleId
  return roleId.includes(2) || roleId.includes('2')
}

/**
 * 获取身份展示名称
 */
export function getRoleDisplayName(role, t) {
  const roleMap = {
    '0': t('游客'),
    '1': t('需求方'),
    '2': t('供应方'),
    '3': t('协调员'),
    '4': t('超管'),
  }
  return roleMap[String(role)] || ''
}

/**
 * 分享链接切换身份提示文案（已登录且有供应方身份）
 */
export function getShareSwitchMessage(currentRole, t) {
  const roleName = getRoleDisplayName(currentRole, t)
  return t('当前登录账号是以{role}身份登录的，需要切换到供应方身份', { role: roleName })
}

/**
 * 分享链接登录提示文案
 */
export function getShareLoginMessage(isLoggedIn, currentRole, t) {
  if (isLoggedIn == 1) {
    const roleName = getRoleDisplayName(currentRole, t)
    return t('当前登录账号是以{role}身份登录的，需要用供应方身份登录', { role: roleName })
  }
  return t('请先使用供应方身份登录')
}



// WEBPACK FOOTER //
// ./src/utils/shareDemandAuth.js